import { useMemo } from "react";
import useGetCurrentUserPermissionScope from "~hooks/useGetCurrentUserPermissionScope.ts";
import type { League } from "~types/league.ts";

export const useExtractLeaguesFromScope = () => {
  const { data: scopeData, isLoading, refetch } = useGetCurrentUserPermissionScope();
  const { scope, resources } = scopeData || {};

  const leagues: League[] = useMemo(() => {
    const leaguesData = resources?.leagues || {};

    return (scope?.leagueTree || [])
      .filter(({ leagueId }) => leagueId && leagueId in leaguesData)
      .map(({ leagueId }) => ({ ...leaguesData[leagueId as string] }));
  }, [scope?.leagueTree, resources?.leagues]);

  return {
    leagues,
    isLoading,
    refetch,
  };
};
